import React from "react";
import MobileStepper from "@material-ui/core/MobileStepper";
import Button from "@material-ui/core/Button";
import SwipeableViews from "react-swipeable-views";
import DealsManagement from "./DealsManagement";
import InvoiceManagement from "./InvoiceManagement";
import Brokerage from "./Brokerage";
import { withRouter } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import Login from "../containers/Login";
class Onboarding extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeStep: 0 };
    if (window.cordova) {
      this.image = `${window.cordova.file.applicationDirectory}www`;
    }
  }
  handleNext = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep + 1
    }));
  };
  handleBack = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep - 1
    }));
  };
  handleStepChange = activeStep => {
    this.setState({ activeStep });
  };
  render() {
    const { classes } = this.props;
    const { activeStep } = this.state;
    const tutorialSteps = [
      <DealsManagement />,
      <InvoiceManagement />,
      <Brokerage />,
      <Login />
    ];
    const maxSteps = tutorialSteps.length;
    return (
      <div
        style={{
          height: "100vh",
          backgroundImage:
            "url('background.jpg'), linear-gradient(#ff4e00, #ec9f05)",
          backgroundBlendMode: "multiply",
          backgroundRepeat: "round"
        }}
      >
        <SwipeableViews
          axis={"x"}
          index={activeStep}
          onChangeIndex={this.handleStepChange}
          enableMouseEvents
        >
          {tutorialSteps.map((step, index) => (
            <div
              style={{
                height: "calc(100vh - 46px)"
              }}
            >
              {activeStep === 0 ? (
                <DealsManagement />
              ) : activeStep === 1 ? (
                <InvoiceManagement />
              ) : activeStep === 2 ? (
                <Brokerage />
              ) : activeStep === 3 ? (
                <Login />
              ) : null}
            </div>
          ))}
        </SwipeableViews>
        <MobileStepper
          style={{ background: "rgba(250, 250, 250, 0)" }}
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          className={classes.mobileStepper}
          nextButton={
            <Button
              size="small"
              onClick={this.handleNext}
              disabled={activeStep === maxSteps - 1}
            >
              Next
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={this.handleBack}
              disabled={activeStep === 0}
            >
              Back
            </Button>
          }
        />
      </div>
    );
  }
}
export default withStyles()(withRouter(Onboarding));
